// extracted by mini-css-extract-plugin
export default {"wrap":"vA-z","fullWidth":"wA-z","searchPlacement":"xA-z","items":"yA-z","featureCss":"zA-z","disabled":"AA-z","imgCss":"BA-z"};